export const COLORS = [
  "#1A79A9", // blue
  "#DD8235", // orange
  "#71CBE0", // light blue
  "#007325", // green
  "#C86E7F", // pink
  "#80C98B", // light green
  "#9286A6", // purple-gray
  "#F2C82B", // yellow
  "#46226A"  // deep purple
];

export default COLORS;

export function getColorForKey(key) {
  const s = String(key || '');
  let hash = 0;
  for (let i = 0; i < s.length; i++) hash = (hash + s.charCodeAt(i)) | 0;
  return COLORS[Math.abs(hash) % COLORS.length];
}

export function getContrastColor(hex) {
  if (!hex || hex[0] !== '#') return '#fff';
  const r = parseInt(hex.substr(1,2),16);
  const g = parseInt(hex.substr(3,2),16);
  const b = parseInt(hex.substr(5,2),16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 160 ? '#000' : '#fff';
}

// Colors per metric group (order: rates, costs, unit_costs, time, energy, emissions)
export const GROUP_COLORS = {
  rates: '#1A79A9',
  costs: '#DD8235',
  unit_costs: '#71CBE0',
  time: '#007325',
  energy: '#C86E7F',
  emissions: '#80C98B',
};

export function colorForGroupIndex(idx) {
  return COLORS[Math.abs(idx) % COLORS.length];
}
